import utils from '../utils'
import ZjStartup from './Startup.vue'
import ZjApp from './App.vue'
import ZjLogin from './Login.vue'
import ZjEmergencyLogin from './EmergencyLogin.vue'
import ZjLoginCarousel from './LoginCarousel.vue'
import ZjLoginForm from './LoginForm.vue'
import ZjEmergencyLoginForm from './EmergencyLoginForm.vue'
import ZjHeader from './Header.vue'
import ZjFooter from './Footer.vue'
import ZjNavMenu from './NavMenu.vue'
import ZjActionPanel from './ActionPanel.vue'
import ZjWorkSpace from './WorkSpace.vue'
import ZjSideMenu from './SideMenu.vue'
import ZjDynamicContainer from './DynamicContainer.vue'
import ZjRouterView from './RouterView.vue'
import ZjIframe from './iFrame.vue'
import ZjHome from './Home.vue'
import ZjNoLogin from './NoLogin.vue'
import ZjNoLoginNew from './NoLoginNew.vue'

import ZjHeaderHegu from './hegu/Header.vue'
import ZjNavMenuHegu from './hegu/NavMenu.vue'
import ZjActionPanelHegu from './hegu/ActionPanel.vue'

const cmps = {
    ZjStartup,
    ZjApp,
    ZjLogin,
    ZjEmergencyLogin,
    ZjLoginCarousel,
    ZjLoginForm,
    ZjEmergencyLoginForm,
    ZjHeader,
    ZjFooter,
    ZjNavMenu,
    ZjActionPanel,
    ZjSideMenu,
    ZjWorkSpace,
    ZjDynamicContainer,
    ZjRouterView,
    ZjIframe,
    ZjHome,
    ZjNoLogin,
    ZjNoLoginNew,
    ZjHeaderHegu,
    ZjNavMenuHegu,
    ZjActionPanelHegu
}

const install = function(Vue) {
    utils.each(cmps, cmp=>Vue.component(cmp.name, cmp))
}

export default {
    install,
    ...cmps
}